const state = {
    prompt: false,
    recipeIngredients: [],
    recipeQueryString: '',
    filter: {},
    search: {},
    charts: null,
    chartHeader: {
        title: null,
        subtitle: null
    },
    groceryListForm: {
        active: false,
        recipeId: null,
        ingredients: [],
        recipeServings: null,
        userId: null
    },
    dietScheduleForm: false,
    menuForm: false,
    isMobile: null,
    measurements: [],
    measurementsCharts: [],
    isEditMode: false,
    selectedServings: 1,
    foodDiaryForm: {
        active: false,
        recipeId: null,
        servings: 1
    }
};

export default state;
